export enum ClassificationType {
  Significant,
  Unclassified,
  FilteredOut
}
